<template>
  <v-layout justify-center>
    <v-slide-x-transition mode="out-in">
      <!-- The button to load more items -->
      <v-flex v-if="categories.length < categoriesCount" shrink key="button">
        <v-btn @click="getCategories" color="blue" dark :loading="loadingCategories" round>
          <v-icon class="pr-2">expand_more</v-icon>Cargar más categorías
        </v-btn>
      </v-flex>
      <!-- The message to show when there no more groups to load -->
      <v-flex
        v-else
        class="grey--text font-italic mt-3"
        shrink
        key="message"
      >No hay más categorías con predicciones</v-flex>
    </v-slide-x-transition>
  </v-layout>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  computed: {
    ...mapState("classifier", [
      "categories",
      "categoriesCount",
      "loadingCategories"
    ])
  },
  methods: {
    ...mapActions("classifier", ["getCategories"])
  }
};
</script>